import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { FadeUp } from '../ui/FadeUp';
export function ImagineSection() {
  return <SectionWrapper bgColor="sand" id="imagine" className="text-center" data-id="element-107">
      <FadeUp data-id="element-108">
        <p className="text-[10px] tracking-[0.2em] uppercase text-muted mb-8" data-id="element-109">
          Imaginá esto
        </p>
      </FadeUp>

      <FadeUp delay={0.1} data-id="element-110">
        <p className="font-serif text-[clamp(22px,6vw,32px)] italic text-charcoal mb-7 leading-[1.3] opacity-85" data-id="element-111">
          Terminar una discusión y{' '}
          <strong className="text-plum font-medium not-italic" data-id="element-112">
            recuperar tu eje
          </strong>{' '}
          en minutos.
        </p>
      </FadeUp>

      <FadeUp delay={0.2} data-id="element-113">
        <div className="w-[1px] h-6 bg-border-custom mx-auto mb-7" data-id="element-114" />
      </FadeUp>

      <FadeUp delay={0.3} data-id="element-115">
        <p className="font-serif text-[clamp(22px,6vw,32px)] italic text-charcoal mb-7 leading-[1.3] opacity-85" data-id="element-116">
          No llevarte el día a la cama.
        </p>
      </FadeUp>

      <FadeUp delay={0.4} data-id="element-117">
        <div className="w-[1px] h-6 bg-border-custom mx-auto mb-7" data-id="element-118" />
      </FadeUp>

      <FadeUp delay={0.5} data-id="element-119">
        <p className="font-serif text-[clamp(22px,6vw,32px)] italic text-charcoal leading-[1.3] opacity-85" data-id="element-120">
          <strong className="text-plum font-medium not-italic" data-id="element-121">Elegir</strong>{' '}
          en lugar de reaccionar.
        </p>
      </FadeUp>
    </SectionWrapper>;
}